import { Breakpoint } from '../../../../BaseComponents/ThemeProvider/AvenyTheme';
import { useIsBreakpointOrSmaller } from '../../../../Components/BreakpointContext/BreakpointContextUtils';

export const showDetailsRightMaxScreenSizeBreakPoint: Breakpoint = 'sm';

const useShowDetailsRightDisabledOnCurrentScreenSize = (): boolean => {
  const showDetailsRightDisabledOnCurrentScreenSize = useIsBreakpointOrSmaller(
    showDetailsRightMaxScreenSizeBreakPoint
  );

  return showDetailsRightDisabledOnCurrentScreenSize;
};

export default useShowDetailsRightDisabledOnCurrentScreenSize;
